import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

function OAuth2RedirectHandler() {
    const { error, loginWithRedirect } = useAuth0();

    if (error) {
        return (
            <div role="alert">
                <h1>Sign-in could not be completed</h1>
                <p>{error.message || "The secure sign-in callback was rejected."}</p>
                <button
                    type="button"
                    onClick={() =>
                        loginWithRedirect({ appState: { returnTo: "/home" } })
                    }
                >
                    Try sign-in again
                </button>
            </div>
        );
    }

    // Auth0Provider owns the code/state exchange and calls onRedirectCallback
    // after it has safely consumed the callback URL. Navigating here would race
    // that exchange and can remove the query string before the SDK reads it.
    return (
        <div role="status" aria-live="polite">
            Completing secure sign-in…
        </div>
    );
}

export default OAuth2RedirectHandler;
